var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2632 19.5444C16.2632 23.7559 12.8625 27.1696 8.66722 27.1696C4.47192 27.1696 1.07129 23.7559 1.07129 19.5444C1.07129 15.333 4.47192 11.9193 8.66722 11.9193C12.8625 11.9193 16.2632 15.333 16.2632 19.5444Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9126 27.8214H0.421875V11.2674H16.9126V27.8214Z",
    fill: "#2E2E30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66749 12.5708C4.83663 12.5708 1.72037 15.6991 1.72037 19.5447C1.72037 23.3894 4.83663 26.5181 8.66749 26.5181C12.498 26.5181 15.6142 23.3895 15.6142 19.5447C15.6142 15.699 12.498 12.5708 8.66749 12.5708ZM8.66749 27.8216C4.12077 27.8216 0.421875 24.1085 0.421875 19.5447C0.421875 14.9804 4.12077 11.2674 8.66749 11.2674C13.2138 11.2674 16.9127 14.9804 16.9127 19.5447C16.9127 24.1085 13.2138 27.8216 8.66749 27.8216Z",
    fill: "#42518D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4361 12.4494C13.0639 13.8481 14.0988 15.9214 14.0988 18.2411C14.0988 22.4521 10.6981 25.8663 6.50285 25.8663C5.52471 25.8663 4.59283 25.6738 3.73413 25.3358C5.06156 26.4767 6.78241 27.1697 8.66694 27.1697C12.8622 27.1697 16.2629 23.7556 16.2629 19.5446C16.2629 16.3151 14.2603 13.5613 11.4361 12.4494Z",
    fill: "#040605"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07129 19.5444C1.07129 19.915 1.09896 20.2791 1.15004 20.6358H16.1845C16.2355 20.2791 16.2633 19.9151 16.2633 19.5444C16.2633 19.1738 16.2355 18.8097 16.1845 18.453H1.15004C1.09792 18.8145 1.0716 19.1792 1.07129 19.5444Z",
    fill: "#C4C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73478 19.9841H15.5997C15.6096 19.836 15.6139 19.6891 15.6139 19.5444C15.6139 19.3994 15.6096 19.2525 15.5997 19.1052H1.73473C1.72525 19.2514 1.72049 19.3979 1.72045 19.5444C1.72045 19.6891 1.72521 19.836 1.73467 19.9841M16.1848 21.2876H1.14963C0.826807 21.2876 0.552822 21.0491 0.506939 20.728C0.450611 20.3304 0.422119 19.9324 0.422119 19.5444C0.422119 19.1564 0.450666 18.758 0.506885 18.3613C0.55326 18.0398 0.826807 17.8017 1.14968 17.8017H16.1849C16.5078 17.8017 16.7818 18.0398 16.8277 18.3613C16.8839 18.758 16.9124 19.1565 16.9124 19.5444C16.9124 19.9324 16.8839 20.3304 16.8277 20.728C16.7822 21.0491 16.5077 21.2876 16.1849 21.2876",
    fill: "#42518D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2542 27.1696C16.2682 27.1696 13.825 24.7169 13.825 21.7195V6.29485C13.825 3.29743 16.2682 0.844696 19.2542 0.844696C22.2403 0.844696 24.6835 3.29743 24.6835 6.29485V21.7195C24.6835 24.7169 22.2403 27.1696 19.2542 27.1696Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2544 1.49658C16.6186 1.49658 14.474 3.64897 14.474 6.29497V21.7196C14.474 24.3656 16.6186 26.518 19.2544 26.518C21.8903 26.518 24.0345 24.3656 24.0345 21.7196V6.29497C24.0345 3.64897 21.8903 1.49658 19.2544 1.49658ZM19.2544 27.8214C15.9027 27.8214 13.1755 25.0842 13.1755 21.7196V6.29497C13.1755 2.93037 15.9027 0.1931 19.2544 0.1931C22.6062 0.1931 25.333 2.93037 25.333 6.29497V21.7196C25.333 25.0842 22.6062 27.8214 19.2544 27.8214Z",
    fill: "#42518D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2542 0.844696C16.2682 0.844696 13.825 3.29732 13.825 6.29485V14.0073H24.6835V6.29485C24.6835 3.29732 22.2403 0.844696 19.2542 0.844696Z",
    fill: "#FFC814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.474 13.3553H24.0345V6.29497C24.0345 3.64897 21.8903 1.49658 19.2544 1.49658C16.6186 1.49658 14.474 3.64897 14.474 6.29497V13.3553ZM24.6837 14.6588H13.8247C13.4664 14.6588 13.1755 14.3668 13.1755 14.0071V6.29502C13.1755 2.93032 15.9027 0.1931 19.2544 0.1931C22.6062 0.1931 25.333 2.93032 25.333 6.29497V14.007C25.333 14.3668 25.0421 14.6588 24.6837 14.6588Z",
    fill: "#42518D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2544 0.844705C18.884 0.844705 18.5225 0.882932 18.1724 0.954627C20.6446 1.46169 22.5196 3.66882 22.5196 6.29486V21.7195C22.5196 24.3455 20.6446 26.5526 18.1724 27.0596C18.5284 27.1327 18.8909 27.1695 19.2544 27.1696C22.2405 27.1696 24.6837 24.7169 24.6837 21.7194V6.29481C24.6837 3.29738 22.2405 0.84465 19.2544 0.84465",
    fill: "#040605"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharma);
export default __webpack_public_path__ + "static/media/Pharma.bb8edd6f835ca9ac1c6dff65b2d62dc7.svg";
export { ForwardRef as ReactComponent };